import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VoiceTypes } from '../../utils/types';
import { CUSTOM_VOICES } from '../../pages/Avatar/constants';

interface VoicesState {
  ttsEngines: string[];
  smartspeechVoices: VoiceTypes[] | [],
  elevenLabsVoices: VoiceTypes[] | [],
  allVoices: VoiceTypes[] | [],
}
  
const initialState: VoicesState = {
    ttsEngines: ["smartspeech", "elevenlabs_regular"],
    smartspeechVoices: [...CUSTOM_VOICES],
    elevenLabsVoices: [],
    allVoices: [...CUSTOM_VOICES],
};

const voicesList = createSlice({
  name: 'voices',
  initialState,
  reducers: {
    setSmartspeechVoices: (state, action: PayloadAction<VoiceTypes[]>) => {
      state.smartspeechVoices = action.payload;
      state.allVoices = [...action.payload, ...state.elevenLabsVoices];
    },
    setElevenLabsVoices: (state, action: PayloadAction<VoiceTypes[]>) => {
      state.elevenLabsVoices = action.payload;
      state.allVoices = [...state.smartspeechVoices, ...action.payload];
    },
  },
});

export const { setSmartspeechVoices, setElevenLabsVoices } = voicesList.actions;
export const voicesListReducer = voicesList.reducer;
